import SlsEmbalagClient from '@/api/SistemaDKP/sls-embalag.client';
import store from '@/store';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';
import S3BucketService from '@/services/s3-bucket.service';
import Notifier from '@/libs/Notifier';

export default class SlsEmbalagService {
  constructor() {
    this.client = new SlsEmbalagClient();
    this.clientMarca = new EsMarcaClient();
    this.store = store;
    this.s3BucketService = new S3BucketService();
    this.notify = new Notifier();
  }

  async findAll() {
    try {
      const { data, ...pagination } = await this.client.getEsEmbalag(this.store.getters['slsEmbalagem/getFilters']);
      this.store.commit('slsEmbalagem/setEsEmbalg', data);
      this.store.commit('slsEmbalagem/setFilters', pagination);
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  async findById(id) {
    try {
      const data = await this.client.getEsEmbalagById(id);
      this.store.commit('slsEmbalagem/setCurrentEsEmbalag', data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async findAllMarcars() {
    try {
      const { data, ...pagination } = await this.clientMarca.getEsMarca({
        page: 1,
        perPage: 100,
      });
      this.store.commit('slsEmbalagem/setOptionsMarcas', data);
    } catch (error) {
      console.log(error);
    }
  }

  async save(hbiEsEmbalag) {
    this.store.commit('slsEmbalagem/setIsLoading', true);
    try {
      const formatData = new FormData();

      formatData.append('caminho_catalogo', hbiEsEmbalag.caminho_catalogo);
      formatData.append('caminho', hbiEsEmbalag.caminho);
      formatData.append('caminho_img_cabec_marcas', hbiEsEmbalag.caminho_img_cabec_marcas);
      formatData.append('caminho_img_footer_principal', hbiEsEmbalag.caminho_img_footer_principal);
      formatData.append('caminho_img_footer_secundaria', hbiEsEmbalag.caminho_img_footer_secundaria);
      formatData.set('cod_marca', hbiEsEmbalag.cod_marca);
      formatData.set('ordem_visualizacao', hbiEsEmbalag.ordem_visualizacao);
      formatData.set('cor_cabecalho_marca', hbiEsEmbalag.cor_cabecalho_marca);

      const { data } = await this.client.postEsEmbalag(formatData);
      this.store.commit('slsEmbalagem/addOfUpdateEsEmbalag', data);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsEmbalagem/setIsLoading', false);
    }
  }

  async update(hbiEsEmbalag) {
    this.store.commit('slsEmbalagem/setIsLoading', true);
    if (!this.store.getters['slsEmbalagem/getIsAlteracao']) {
      this.notify.info('Nenhuma alteração foi realizada');
      this.store.commit('slsEmbalagem/setIsLoading', false);
      return;
    }
    try {
      const formatData = new FormData();

      formatData.append('caminho_catalogo', hbiEsEmbalag.caminho_catalogo);
      formatData.append('caminho', hbiEsEmbalag.caminho);
      formatData.append('caminho_img_cabec_marcas', hbiEsEmbalag.caminho_img_cabec_marcas);
      formatData.append('caminho_img_footer_principal', hbiEsEmbalag.caminho_img_footer_principal);
      formatData.append('caminho_img_footer_secundaria', hbiEsEmbalag.caminho_img_footer_secundaria);
      formatData.set('cod_marca', hbiEsEmbalag.cod_marca);
      formatData.set('ordem_visualizacao', hbiEsEmbalag.ordem_visualizacao);
      formatData.set('cor_cabecalho_marca', hbiEsEmbalag.cor_cabecalho_marca);

      const { data } = await this.client.putEsEmbalag(hbiEsEmbalag.log_img_id, formatData);
      this.store.commit('slsEmbalagem/addOfUpdateEsEmbalag', data);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsEmbalagem/setIsLoading', false);
    }
  }

  async delete(id) {
    this.store.commit('slsEmbalagem/setIsLoading', true);
    try {
      const { data } = await this.client.deleteEsEmbalag(id);
      this.store.commit('slsEmbalagem/deleteEsEmbalag', id);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsEmbalagem/setIsLoading', false);
    }
  }
}
